import * as React from 'react';
const SvgHackerrank = (props) => (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0_1781_5089)">
      <rect x="-1" y="-0.5" width="16" height="16" rx="4" fill="black" />
      <rect
        x="7.09229"
        y="4.23193"
        width="5.64815"
        height="7.90074"
        fill="#2AE567"
      />
      <rect
        x="1.53711"
        y="4.23193"
        width="6.18056"
        height="6.61397"
        fill="white"
      />
      <path
        d="M-1.88916 7.50052V17.3829H15.8886V-2.38184H-1.88916V7.50052ZM3.94195 5.45377L3.96565 6.66601H5.37998V4.2064H6.88121V10.7946H5.37998V8.33503H3.96565L3.94195 9.53848L3.91825 10.7507L3.19133 10.7771L2.45652 10.8034V4.19762L3.19133 4.22397L3.91825 4.25032L3.94195 5.45377ZM12.0249 7.50052V10.7507L9.84417 10.7771L7.67133 10.7946V4.2064L9.84417 4.22397L12.0249 4.25032V7.50052Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_1781_5089">
        <rect
          x="0.333496"
          y="0.5"
          width="13.6667"
          height="13.6667"
          rx="2"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgHackerrank;
